module.exports = __webpack_public_path__ + "static/media/Societe-Analyse-Immobiliere-Vaud.50ac2f08.jpg";